if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
    if (event.source !== 'product-form') return;
    var item = event.cartData;
    if (!item || !item.product_id) return;
    try {
      cX.callQueue.push([
        'sendEvent',
        'add_cart',
        { product_id: String(item.product_id), variant_id: String(item.variant_id || item.id || '') },
      ]);
    } catch (e) {}
  });

  subscribe(PUB_SUB_EVENTS.variantChange, function () {
    try {
      pianoSpaTracking();
      tp.experience.execute();
    } catch (e) {}
  });
}

document.addEventListener(
  'click',
  function (evt) {
    var button = evt.target.closest('.mxpr-favorites-button');
    if (!button || !window.__pianoProductId) return;
    if (!/追加する/.test(button.textContent)) return;
    try {
      cX.callQueue.push(['sendEvent', 'add_wishlist', { product_id: String(window.__pianoProductId) }]);
    } catch (e) {}
  },
  true
);
